import React from 'react'
import Footer from '../components/footer.componets'
import Instagram from '../components/instagram.componets'
import Product from '../components/product.componets'
import ShopSidbar from '../components/shop-sidbar.components'
const Shop = () => {


    return (
        <>
            <section class="shop spad">
                <div class="container">
                    <div class="row">
                        {/* shop_sidbar */}
                        <ShopSidbar />
                        <div class="col-lg-9 col-md-9">
                            <Product shopProduct = {true} />
                        </div>
                    </div>
                </div>
            </section>
            <Instagram />
            <Footer/>
        </>
    )
}

export default Shop